import React, { useState, useEffect } from 'react';
import { Link } from 'react-router';

const TestimonialsSection = ({ testimonials = [] }) => {
  // Default testimonials if none are provided
  const defaultTestimonials = [
    {
      text: "Very hygenic clinic. Dr. Aesha and her staff provides a comfortable and caring environment .she explain clearly treatment options & prioritize patient comfort throughout the entire process. my 9 yr old daughter got treatment from pristine smile and shw wrote review by her self. Highly recommend for dental treatment.",
      author: "Flourish Biotech",
      borderColor: "border-teal-500",
      cornerColor: "bg-teal-100"
    },
    {
      text: "Dr. Aesha Thakkar is an experienced professional, with a gentle touch that puts even the most anxious patients at ease. Her expertise in tooth implants, root canals, and other dental issues is unmatched. She's not only an exceptional dentist, but also a kind and compassionate person who truly listens to her patients and I've always felt confident in her care. Her extensive experience and expertise shine through in every aspect of her care. Highly, highly recommend!",
      author: "Mohan Lal",
      borderColor: "border-lime-500",
      cornerColor: "bg-lime-100"
    },
    {
      text: "I am very satisfied with the work of Dr.Aesha .. clinic service and ambiance and treatment protocol is very good . No problem at all after my treatment I can eat everything.. I got my full teeth set .. M happy and very helpful with installment payment facilities.. Nature of doctor and staff is very good.. Appointment scheduled is very punctual and maintaining systematically..",
      author: "Sunil Kumar",
      borderColor: "border-teal-500",
      cornerColor: "bg-teal-100"
    }
  ];

  // Use provided testimonials or fall back to defaults
  const allTestimonials = testimonials.length > 0 ? testimonials : defaultTestimonials;
  
  // State management
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  const [direction, setDirection] = useState('right');
  
  // Function to alternate colors
  const getColor = (index) => {
    const colors = [
      { border: "border-teal-500", corner: "bg-teal-100" },
      { border: "border-lime-500", corner: "bg-lime-100" }
    ];
    return colors[index % colors.length];
  };
  
  // Calculate visible testimonials based on screen size
  const getVisibleCount = () => {
    if (typeof window === 'undefined') return 3; // SSR fallback
    if (window.innerWidth >= 1280) return 3; // xl
    if (window.innerWidth >= 1024) return 3; // lg
    if (window.innerWidth >= 768) return 2; // md
    return 1; // sm and xs
  };
  
  const [visibleCount, setVisibleCount] = useState(3);
  
  // Update visible count on window resize
  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount());
    };
    
    handleResize(); // Initial call
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Auto rotation logic
  useEffect(() => {
    if (!isAutoPlay) return;
    
    const interval = setInterval(() => {
      if (direction === 'right') {
        setActiveIndex((prev) => (prev + 1) % allTestimonials.length);
      } else {
        setActiveIndex((prev) => (prev - 1 + allTestimonials.length) % allTestimonials.length);
      }
    }, 3000);
    
    return () => clearInterval(interval);
  }, [isAutoPlay, direction, allTestimonials.length]);
  
  // Get testimonials to display in the current view
  const getVisibleTestimonials = () => {
    const result = [];
    for (let i = 0; i < visibleCount; i++) {
      const index = (activeIndex + i) % allTestimonials.length;
      result.push({
        ...allTestimonials[index],
        index
      });
    }
    return result;
  };
  
  // Handlers
  const handleNext = () => {
    setDirection('right');
    setActiveIndex((prev) => (prev + 1) % allTestimonials.length);
    setIsAutoPlay(false);
    setTimeout(() => setIsAutoPlay(true), 5000);
  };
  
  const handlePrev = () => {
    setDirection('left');
    setActiveIndex((prev) => (prev - 1 + allTestimonials.length) % allTestimonials.length);
    setIsAutoPlay(false);
    setTimeout(() => setIsAutoPlay(true), 5000);
  };
  
  const handleMouseEnter = () => setIsAutoPlay(false);
  const handleMouseLeave = () => setIsAutoPlay(true);

  return (
    <div className="mx-auto px-4 sm:px-6 lg:px-8 xl:px-20 py-20 bg-gradient-to-b from-white to-teal-50">
      {/* Header Section */}
      <div className="mb-12">
        <div className="text-6xl text-lime-500 mb-4">"</div>
        <h2 className="text-4xl font-serif text-teal-600 mb-6">
          Kind words from<br />our patients
        </h2>
        <div className="flex items-center gap-2 mb-4">
          {[...Array(5)].map((_, i) => (
            <svg key={i} className="w-6 h-6 text-lime-500" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          ))}
        </div>
        <Link 
          to='https://www.google.com/maps/place/Pristine+Smile/@22.3010117,73.1394524,17z/data=!4m8!3m7!1s0x395fc956227309d5:0x79a69c5171205095!8m2!3d22.3010117!4d73.1394524!9m1!1b1!16s%2Fg%2F11wm_tmsy_?entry=ttu&g_ep=EgoyMDI1MDMxOS4yIKXMDSoASAFQAw%3D%3D'
          target='_blank' 
          className="text-lg text-teal-700 font-medium hover:text-teal-500 transition-colors">
          Every Patient. Every Visit. 5 Stars.
          <span className="ml-2 inline-block border-b-2 border-lime-400">→</span>
        </Link>
      </div>

      {/* Testimonials Carousel */}
      <div 
        className="relative"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Navigation Buttons */}
        <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10">
          <button 
            onClick={handlePrev}
            className="bg-white rounded-full p-2 shadow-md hover:shadow-lg transition-shadow text-teal-600 hover:text-teal-700"
            aria-label="Previous testimonial"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        </div>
        
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10">
          <button 
            onClick={handleNext}
            className="bg-white rounded-full p-2 shadow-md hover:shadow-lg transition-shadow text-teal-600 hover:text-teal-700"
            aria-label="Next testimonial"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
        
        {/* Testimonials Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {getVisibleTestimonials().map((testimonial, i) => {
            const colorSet = testimonial.borderColor && testimonial.cornerColor
              ? { border: testimonial.borderColor, corner: testimonial.cornerColor }
              : getColor(testimonial.index);
              
            return (
              <div 
                key={`${testimonial.author}-${testimonial.index}`}
                className={`bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all relative border-t-4 ${colorSet.border} h-full transform transition-transform duration-500 ${i === 0 ? 'animate-fadeIn' : ''}`}
              >
                <p className="mb-8 text-gray-700 leading-relaxed">
                  {testimonial.text.length > 150 
                    ? `${testimonial.text.substring(0, 150)}...` 
                    : testimonial.text}
                </p>
                <div className="absolute bottom-6">
                  <p className="font-medium text-teal-600">— {testimonial.author}</p>
                </div>
                <div className={`absolute bottom-0 right-0 w-12 h-12 ${colorSet.corner} rounded-tr-2xl`}></div>
              </div>
            );
          })}
        </div>
        
        {/* Pagination Indicators */}
        <div className="flex justify-center mt-8 space-x-2">
          {allTestimonials.map((_, index) => (
            <button
              key={index}
              className={`w-3 h-3 rounded-full transition-colors ${
                index === activeIndex ? 'bg-teal-500' : 'bg-teal-200'
              }`}
              onClick={() => {
                setActiveIndex(index);
                setIsAutoPlay(false);
                setTimeout(() => setIsAutoPlay(true), 5000);
              }}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
      
      {/* Call to Action Button */}
      <div className="mt-12 text-center">
        <a
          target='_blank' 
          href='https://www.google.com/maps/place/Pristine+Smile/@22.3010117,73.1394524,17z/data=!4m8!3m7!1s0x395fc956227309d5:0x79a69c5171205095!8m2!3d22.3010117!4d73.1394524!9m1!1b1!16s%2Fg%2F11wm_tmsy_?entry=ttu&g_ep=EgoyMDI1MDMxOS4yIKXMDSoASAFQAw%3D%3D' 
          className="px-8 py-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-lg shadow-md hover:shadow-lg transition-shadow">
          Read More Patient Reviews
        </a>
      </div>
    </div>
  );
};

export default TestimonialsSection;